export const imageAccommodation = {
  breadcrumbCurrent: "Accommodation logo",
  heading: "Your listing logo",
  subtitle:
    "Upload the logo that identifies this listing. Allowed formats: PNG, JPG, SVG · max. 5 MB.",
  savedLogoAlt: "Saved logo",
  activeBadge: "Active logo",
  change: "Change",
  drop: {
    release: "Drop it here",
    newLogo: "New logo",
    uploadLogo: "Upload your logo",
    dragOr: "Drag or",
    clickLink: "click",
    formats: "PNG · JPG · SVG · max. 5 MB",
  },
  importButton: "Import logo from another listing",
  crop: {
    removeImage: "Remove image",
    tip: "Move and adjust the crop. 2:1 ratio (ideal for horizontal logos).",
    saving: "Saving…",
    save: "Save logo",
  },
  actions: {
    cancel: "Cancel",
  },
  applyModal: {
    title: "Apply to other listings?",
    subtitle: "Select the listings you want to copy this same logo to.",
    logoAlt: "Logo",
    selectAll: "Select all",
    progress: "Applying {done}/{total}…",
    skip: "Skip",
    applying: "Applying…",
    applyToBtn: "Apply to {count} listing | Apply to {count} listings",
  },
  importModal: {
    title: "Import logo",
    subtitle: "Choose the logo from another listing to use in this one.",
    loading: "Loading listings…",
    empty: "No listing has a logo yet.",
    progress: "Importing logo…",
    importing: "Importing…",
  },
  defaultListingName: "Listing",
  toasts: {
    invalidFormat: "Invalid format. Use PNG, JPG or SVG.",
    fileTooLarge: "The file exceeds the {max} MB limit.",
    selectBeforeSave: "Select and adjust a logo before saving.",
    propertyNotFound: "The property linked to this listing was not found.",
    saveSuccess: "Logo saved successfully",
    saveError: "Error saving the logo.",
    listingLoadError: "The listing details could not be loaded.",
    applySuccess:
      "Logo applied to {count} listing successfully | Logo applied to {count} listings successfully",
    applyError:
      "Could not apply to {count} listing | Could not apply to {count} listings",
    listingsLoadError: "The listings could not be loaded.",
    propertyNotFoundImport: "The property for this listing was not found.",
    importSuccess: 'Logo from "{name}" imported successfully',
    importError: "Error importing the logo.",
  },
};
